import axios from 'axios';
import { API_URL } from '../config';

export async function getTransportStockRows(params) {
  const response = await axios.get(`${API_URL}/transport-stock/rows`, {
    params,
    withCredentials: true,
  });
  return response.data;
}

export async function getTransportStockHistory(params) {
  const response = await axios.get(`${API_URL}/transport-stock/imports`, {
    params,
    withCredentials: true,
  });
  return response.data;
}

export async function importTransportStock(file) {
  const data = new FormData();
  data.append('file', file);
  const response = await axios.post(
    `${API_URL}/transport-stock/imports`,
    data,
    { withCredentials: true },
  );
  return response.data;
}
